import React from 'react';

/**
 * SB-10310 — one custom field value. Rich-text ("wysiwyg") fields arrive with
 * `<internal_name>Html`, sanitized on the server, and render as markup so
 * bullets and bold show instead of "<p>…</p>". Every other value stays text.
 *
 * @param {{ html?: string | null, className: string, children: React.ReactNode }} props
 */
const FieldTextValue = ({ html, className, children }) => {
  // Any string is the sanitized result and wins, even an empty one: falling
  // back to `children` there would print the raw value the server cleaned.
  if (typeof html === 'string') {
    return <div className={`${className} sb-rich-text`} dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return <span className={className}>{children}</span>;
};

export default FieldTextValue;
